import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from '../index';
import { documentDetectionFeatureKey, DocumentDetectionState } from '../reducers/detection.reducer';

export const selectDocumentDetection = createFeatureSelector< DocumentDetectionState>(documentDetectionFeatureKey);
export const getDetection = createSelector(selectDocumentDetection, data => data.detection);
